import ClientList from './components/ClientList';

const Inactive = () => {
  return (
    <ClientList
      title="Inactive Clients"
      initialFilters={[
        {
          attribute: 'status',
          operator: 'EQ',
          value: 'INACTIVE',
        },
      ]}
      editableColumns={['contractSigned', 'terminatedAt']}
      defaultColumns={[
        'client',
        'status',
        'brandStrategist',
        'accountSpecialist',
        'contractSigned',
        'terminatedAt',
        'terminationReason',
      ]}
      allowedFilters={[
        'invoiceSummary',
        'accountStatus',
        'subscriptionStatus',
        'terminatedAt',
        'terminationReason',
        'brandStrategist',
        'accountSpecialist',
        'subscriptionPaymentOption',
      ]}
      initialParams={{
        page: 1,
        pageSize: 10,
        sorts: 'client:asc',
        search: '',
        filters: '[]',
        include: [
          'subscription',
          'defaultContact',
          'projectManager[user[avatar]]',
          'brandStrategist[user[avatar]]',
          'accountSpecialist[user[avatar]]',
        ],
        attributes: [
          'phone',
          'client',
          'status',
          'service',
          'address',
          'website',
          'terminatedAt',
          'isOnboarding',
          'accountStatus',
          'amazonPageUrl',
          'agencyClientId',
          'draftMarketplace',
          'contractSigned',
          'terminationReason',
          'invoiceSummary',
          'salesClientId',
          'totalPaidInvoiceAmount',
          'totalUnPaidInvoiceAmount',
          'subscriptionPaymentOption',
        ],
      }}
    />
  );
};

export default Inactive;
